module.exports = __webpack_public_path__ + "bg.2HU-91hT.svg";